import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=7b55248c"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports